/* eslint-disable import/no-unresolved */
import { handelIndianCurrencyChange, onChangeIndianCurrency } from "src/helpers/FormDetails";
import CovidDetailsTogglebutton from "src/shared/CovidDetailsToggleButton";
import CustomTextField from "src/shared/CustomTextField";

interface Props {
  formik: any;
}

function SalaryDetails({ formik }: Props) {
  return (
    <div>
      <div className="flex justify-between">
        <p className="text-daintree font-montserrat text-sm font-medium mb-6 w-89/100">
          If you are salaried then, please give the details of company, Designation & monthly income
          from employment abroad? (Also mentioned details of currency)*
        </p>
        <CovidDetailsTogglebutton
          isEnabled
          toggleState={formik.values.salaried.isSalaried}
          fieldObj="salaried"
          fieldName="isSalaried"
          setFieldValue={formik.setFieldValue}
        />
      </div>
      {formik.values.salaried.isSalaried && (
        <div className="flex flex-col md:flex-row justify-between">
          <div className="w-full md:w-222/1000 mb-6 md:mb-0">
            <CustomTextField
              requiredStar
              label="Company Name"
              className=""
              // onChange={handleChange("salaried.companyName")}
              onChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              value={formik.values.salaried?.companyName}
              name="salaried.companyName"
              error={formik.errors.salaried?.companyName}
              touched={formik.touched.salaried?.companyName}
            />
          </div>
          <div className="w-full md:w-222/1000 mb-6 md:mb-0">
            <CustomTextField
              requiredStar
              label="Designation"
              className=""
              // onChange={handleChange("salaried.designation")}
              onChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              value={formik.values.salaried?.designation}
              name="salaried.designation"
              error={formik.errors.salaried?.designation}
              touched={formik.touched.salaried?.designation}
            />
          </div>
          <div className="w-full md:w-222/1000 mb-6 md:mb-0">
            <CustomTextField
              requiredStar
              label="Currency"
              className=""
              // options={["Rupee", "Dollar"]}
              // onChange={handleChange("salaried.currency")}
              onChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              // setFieldTouched={formik.setFieldTouched}
              name="salaried.currency"
              value={formik.values.salaried?.currency}
              error={formik.errors.salaried?.currency}
              touched={formik.touched.salaried?.currency}
            />
          </div>
          <div className="w-full md:w-222/1000 mb-6 md:mb-0">
            <CustomTextField
              requiredStar
              label="Monthly Income"
              className=""
              // onChange={handleChange("salaried.monthlyIncome")}
              onChange={(event) => handelIndianCurrencyChange(event, formik)}
              handleBlur={formik.handleBlur}
              value={onChangeIndianCurrency(formik.values.salaried.monthlyIncome)}
              name="salaried.monthlyIncome"
              error={formik.errors.salaried?.monthlyIncome}
              touched={formik.touched.salaried?.monthlyIncome}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default SalaryDetails;
